// FILE: src/utils/firebase/index.js

// Invitations
import * as InvitationFetchers from "./features/invitations/fetchers";
import * as InvitationWriters from "./features/invitations/writers";

// Accounts
import * as AccountsFetchers from "./features/accounts/fetchers";
import * as AccountsWriters from "./features/accounts/writers";

// Tags
import * as TagsFetchers from "./features/tags/fetchers";
import * as TagsWriters from "./features/tags/writers";

// Transactions (includes delta fetcher)
import * as TransactionsFetchers from "./features/transactions/fetchers";
import * as TransactionsWriters from "./features/transactions/writers";

// Rules
import * as RulesFetchers from "./features/rules/fetchers";

// System
import * as SystemFetchers from "./features/system/fetchers";
import * as SystemWriters from "./features/system/writers";

// Auth
import * as AuthFetchers from "./features/auth/fetchers";
import * as AuthWriters from "./features/auth/writers";

// Income Tax
import * as InTaxFetchers from "./features/intax/fetchers";
import * as InTaxWriters from "./features/intax/writers";

import { isFirebaseReady, notReadyReason, getFirebase } from "./core/firebaseApp";

/**
 * AuthAPI
 * - Core app readiness methods
 * - Auth feature methods (fetchers + writers)
 */
export const AuthAPI = Object.freeze({
  // core
  isFirebaseReady,
  notReadyReason,
  getFirebase,

  // feature functions
  ...AuthFetchers,
  ...AuthWriters,

  // backward-compat alias (deprecated)
  /** @deprecated Use AuthAPI.loginWithGoogle instead. */
  fcLoginWithGoogle: AuthWriters.loginWithGoogle,
});

/** Composed feature APIs (read/write where applicable). */
export const InvitationAPI = Object.freeze({ ...InvitationFetchers, ...InvitationWriters });
export const AccountsAPI   = Object.freeze({ ...AccountsFetchers,   ...AccountsWriters   });
export const TagsAPI       = Object.freeze({ ...TagsFetchers,       ...TagsWriters       });
export const TransactionsAPI = Object.freeze({
  ...TransactionsFetchers,  // includes fetchUserTransactionsDelta, fetchUserTransactionsRange, etc.
  ...TransactionsWriters,   // writers with write-through cache patching
});
export const RulesAPI      = Object.freeze({ ...RulesFetchers });
export const SystemAPI     = Object.freeze({ ...SystemFetchers, ...SystemWriters });
export const InTaxAPI      = Object.freeze({ ...InTaxFetchers, ...InTaxWriters });

/**
 * (Optional named re-exports)
 * If you prefer direct named imports in some places:
 *   import { fetchUserTransactionsDelta } from '.../utils/firebase';
 * uncomment below.
 */
// export const { fetchUserTransactionsDelta } = TransactionsFetchers;
// export const { fetchUserTransactionsRange } = TransactionsFetchers;
// export const { createManualTransaction, updateManualTransaction, deleteTransactions } = TransactionsWriters;
